<template>
  <div style>
    <el-card class="box-card">
      <div>
        <div class="item">订单编号：{{order.id}}</div>
        <div class="item">设备编号：{{order.deviceId}}</div>
        <div class="item">套餐名称：{{order.orderPackage.packageName}}</div>
        <div class="item">订单金额：{{order.orderPackage.packagePrice*order.quantity}}</div>
        <div class="item">订单状态：{{orderStatus[order.status]}}</div>
        <div v-if="startSuccess" class="success">
          <el-alert title="启动成功" description="设备已成功启动！" type="success" show-icon :closable="false"></el-alert>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import axios from "axios";
const instance = axios.create({
  baseURL: "",
  timeout: 0,
  headers: { "token-staff": localStorage.getItem("token-staff") }
});
let loading = null;
export default {
  data() {
    return {
      order: {
        id: null,
        deviceId: null,
        quantity: null,
        status: null,
        orderPackage: {}
      },
      startSuccess: false,
      orderStatus: ["待支付", "启动中", "启动成功", "启动失败", "订单关闭"]
    };
  },
  created: function() {
    let that = this;
    let id = that.$route.params.orderId;
    if (!id) {
      that.$message({
        message: "订单id不存在请重新扫码！",
        type: "warning",
        duration: 2000,
        onClose: function() {}
      });
    } else {
      this.api.client.getOrder({ id: id }).then(response => {
        if (!response.data.errorCode) {
          Object.assign(that.order, response.data.data);
        }
      });
      this.api.client
        .payStatus({ paymentId: that.$route.params.paymentId })
        .then(response => {
          if (!response.data.errorCode) {
            if (!response.data.data) {
              that.$message({
                message: "订单未支付成功，请重新支付！",
                type: "warning",
                duration: 2000,
                onClose: function() {
                  that.$router.push({
                    path: "/client/main/order?id=" + id
                  });
                }
              });
            } else {
              loading = this.$loading({
                lock: true,
                text: "正在启动设备...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
              });
              that.queryStatus(id);
            }
          }
        });
    }
  },
  methods: {
    queryStatus(id) {
      let that = this;
      instance.get(`/client/device/order/${id}`).then(response => {
        if (!response.data.errorCode) {
          Object.assign(that.order, response.data.data);
          if (response.data.data.status == 1) {
            setTimeout(() => {
              that.queryStatus(response.data.data.id);
            }, 5000);
          } else if (response.data.data.status == 2) {
            loading.close();
            that.startSuccess = true;
          } else if (response.data.data.status == 3) {
            loading.close();
            this.$message.error("设备启动失败，款项将自动退回！");
          }
        }
      });
    }
  }
};
</script>
<style scoped>
.item {
  padding: 12px;
  font-size: 14px;
}
.center {
  text-align: center;
  padding: 30px;
}
.item-radio {
  width: 100%;
  margin-left: 0px;
  line-height: 35px;
}
</style>


// WEBPACK FOOTER //
// pay.vue?1a62f8ac